export default "__VITE_ASSET__5aed5dde__"